import React, { LazyExoticComponent } from 'react';

import { RequiredRoles } from '@/utils/permissions.util.ts';

// Use string-based permission codes to allow custom app-level permissions

export enum RouteEnum {
  ADMIN = '/admin/*',
  ADMIN_CERTIFICATION = '/admin/certification',
  ADMIN_CERTIFICATION_DETAIL = '/admin/certification/:certificationId',
  ADMIN_CERTIFICATION_DEVELOPMENT_CENTER_STAGE = '/admin/certification/:certificationId/development-center-stage',
  ADMIN_CERTIFICATION_EXAM_STAGE = '/admin/certification/:certificationId/exam-stage',
  ADMIN_CERTIFICATION_EXAM_STAGE_CONFIG = '/admin/certification/:certificationId/exam-stage/config',
  ADMIN_CERTIFICATION_EXAM_STAGE_DAY = '/admin/certification/:certificationId/exam-stage/exam-days/:dayId',
  ADMIN_CERTIFICATION_EXAM_STAGE_DAYS = '/admin/certification/:certificationId/exam-stage/exam-days',
  ADMIN_CERTIFICATION_EXAM_STAGE_EXAM = '/admin/certification/:certificationId/exam-stage/exam-days/:dayId/exam/:examId',
  ADMIN_CERTIFICATION_EXAM_STAGE_PARTICIPANTS = '/admin/certification/:certificationId/exam-stage/participants',
  ADMIN_CERTIFICATION_LIST = '/admin/certification/list',
  ADMIN_CERTIFICATION_PARTICIPANTS = '/admin/certification/:certificationId/participants',
  ADMIN_CERTIFICATION_SURVEY_DETAIL = '/admin/certification/surveys/:surveyId',
  ADMIN_CERTIFICATION_TEST_STAGE = '/admin/certification/:certificationId/test-stage',
  ADMIN_CERTIFICATION_TEST_STAGE_TERM = '/admin/certification/:certificationId/test-stage/term/:termId',
  ADMIN_ROOT = '/admin',
  AREA = '/area/*',
  AREA_ROOT = '/area',
  CERTIFICATION = '/certification',
  CONTACT = '/contact',
  EMPLOYEE_PROFILE_NEW = '/employee/:id/*',
  EXAMINEE_EXAM = '/certifications/:certificationId/stages/:stageId/exam/:examId',
  FORBIDDEN = '/forbidden',
  LOGIN_SUCCESSFUL = '/login-successful',
  MY_PROFILE = '/my-profile/*',
  MY_PROFILE_DASHBOARD = '/my-profile/dashboard',
  NESTED_STRUCTURE = '/structure/nested',
  NEWS = '/news',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '/not-found',
  NOTIFICATIONS = '/notifications',
  ORGANIZATION_CHART = '/structure/organization',
  ROOT = '/',
  SUCCESSION = '/succession',
  SUCCESSION_CHANGELOG = '/succession/change-log',
  SURVEY_FILL = '/surveys/:surveyId/fill',
  SURVEY_SUMMARY = '/surveys/:surveyId/summary',
  TEAM = '/team',
  TEST_FILL = '/certifications/:certificationId/stages/:stageId/terms/:termId/test/fill',
  TEST_RESULT = '/certifications/:certificationId/stages/:stageId/terms/:termId/test/result',
  TEST_TERM_UNAVAILABLE = '/certifications/:certificationId/stages/:stageId/terms/:termId/test/unavailable',
}

export interface RouteModel {
  component: LazyExoticComponent<React.FC> | React.FC;
  path: RouteEnum;
  permissions: (string[] | string)[];
  roles?: RequiredRoles;
}
